interface ListingFlagsProps {
  highPriority: boolean;
  cardOnly: boolean;
  flags: string[];
}

/** High-priority / card-only / evaluator flags as compact pills. */
export default function ListingFlags({ highPriority, cardOnly, flags }: ListingFlagsProps) {
  const items: { key: string; label: string; className: string }[] = [];
  if (highPriority) {
    items.push({
      key: 'high_priority',
      label: '★ High priority',
      className: 'bg-red-100 text-red-800 border-red-200',
    });
  }
  if (cardOnly) {
    items.push({
      key: 'card_only',
      label: 'Card only',
      className: 'bg-gray-100 text-gray-600 border-gray-200',
    });
  }
  for (const flag of flags) {
    items.push({
      key: `flag-${flag}`,
      label: flag,
      className: 'bg-blue-50 text-blue-700 border-blue-100',
    });
  }
  if (items.length === 0) return null;
  return (
    <span className="inline-flex flex-wrap gap-1">
      {items.map((item) => (
        <span
          key={item.key}
          className={`inline-flex items-center px-1.5 py-0.5 rounded text-[11px] font-medium border ${item.className}`}
        >
          {item.label}
        </span>
      ))}
    </span>
  );
}
